import {DropsMain, DropsPackageList} from '~/apis/point'
import type { dropsPackageList } from '~/apis/point/type'

interface PointState {
  isVisible: boolean
  dropsPackageList: dropsPackageList[] | []
}
export const usePoint = () => {
  const { trackEvent } = useAnalytics()
  const app = useAppStore()
  
  const state = useState<PointState>('point', () => ({
    isVisible: false,
    dropsPackageList: [],
  }))
  const preventScroll = () => {
    if (process.client) {
      document.body.style.overflow = 'hidden'
    }
  }

  const allowScroll = () => {
    if (process.client) {
      document.body.style.overflow = ''
    }
  }
  const showDropsPackageLoad = () => {
    // GA 이벤트: 포인트 충전 팝업 열기
    trackEvent('point_popup_opened', {
      event_category: 'payment',
      user_points: app.user.POINT ?? 0,
      um_idx: app.user.UM_IDX ?? '',
      timestamp: new Date().toISOString()
    })
    
    state.value.isVisible = true
    preventScroll()
  }
  const hideDropsPackageLoad = () => {
    // GA 이벤트: 포인트 충전 팝업 닫기
    trackEvent('point_popup_closed', {
      event_category: 'payment',
      user_points: app.user.POINT ?? 0,
      um_idx: app.user.UM_IDX ?? '',
      timestamp: new Date().toISOString()
    })
    
    state.value.isVisible = false
    allowScroll()
  }
  const getDropsPackageList = async () => {
    try {
      const res = await DropsPackageList()
      if (res.data.code === '200') {
        state.value.dropsPackageList = res.data.data
        
        // GA 이벤트: 포인트 패키지 목록 로드 성공
        trackEvent('point_packages_loaded', {
          event_category: 'payment',
          packages_count: res.data.data.length,
          um_idx: app.user.UM_IDX ?? '',
          timestamp: new Date().toISOString()
        })
      } else {
        // GA 이벤트: 포인트 패키지 목록 로드 실패
        trackEvent('point_packages_load_error', {
          event_category: 'payment',
          error_code: res.data.code,
          error_message: res.data.message || 'Unknown error',
          um_idx: app.user.UM_IDX ?? '',
          timestamp: new Date().toISOString()
        })
      }
    } catch (error) {
      // GA 이벤트: 포인트 패키지 목록 로드 예외
      trackEvent('point_packages_load_exception', {
        event_category: 'payment',
        error_message: error.message || 'Network error',
        um_idx: app.user.UM_IDX ?? '',
        timestamp: new Date().toISOString()
      })
    }
  }
  const getTotalDrops = async () => {
    try {
      const app = useAppStore()
      const res = await DropsMain({
        UM_IDX: app.user.UM_IDX,
      })
      
      const newPointValue = res.data.data.UM_POINT || 0
      const previousPointValue = app.user.POINT || 0
      app.user.POINT = newPointValue
      
      // GA 이벤트: 사용자 포인트 조회
      trackEvent('user_points_refreshed', {
        event_category: 'payment',
        previous_points: previousPointValue,
        current_points: newPointValue,
        points_changed: newPointValue !== previousPointValue,
        points_difference: newPointValue - previousPointValue,
        um_idx: app.user.UM_IDX ?? '',
        timestamp: new Date().toISOString()
      })
    } catch (error) {
      // GA 이벤트: 포인트 조회 실패
      trackEvent('user_points_refresh_error', {
        event_category: 'payment',
        error_message: error.message || 'Network error',
        um_idx: app.user.UM_IDX ?? '',
        timestamp: new Date().toISOString()
      })
    }
  }

  return {
    state,
    showDropsPackageLoad,
    hideDropsPackageLoad,
    getDropsPackageList,
    getTotalDrops,
  }
}